import { render, staticRenderFns } from "./SettingsBehaviourPanel.vue?vue&type=template&id=7e25f2cc"
import script from "./SettingsBehaviourPanel.vue?vue&type=script&lang=ts"
export * from "./SettingsBehaviourPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports